import { changeShippinglineErrorMessages, RenderSeaCardProps, seaErrorMessageMap } from "entities/shared/seaCard.types";
import { RenderSeaSearchErrorCardProps } from "entities/shared/seaCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";

import { SeaSearchCardModel } from "../model/model";

type SeaSearchCardProps = {
  shipmentType: ValueOf<typeof ShipmentType>;
  data: SeaSearchCardModel;
  isAuthenticated: boolean;
  className?: string;
  openCard: (data: SeaSearchCardModel) => void;
  deleteCardHandler: (card: SeaSearchCardModel) => void;
  follow: (card: SeaSearchCardModel) => void;
  isFollowButtonVisible: boolean;
  isFollowLoading: boolean;
  renderCard: (props: RenderSeaCardProps) => JSX.Element;
  renderErrorCard: (props: RenderSeaSearchErrorCardProps) => JSX.Element;
};

export const SeaSearchCard: RFC<SeaSearchCardProps> = ({
  shipmentType,
  data,
  isAuthenticated,
  openCard,
  deleteCardHandler,
  follow,
  isFollowButtonVisible,
  isFollowLoading,
  renderCard,
  renderErrorCard,
}) => {
  const { t } = useTranslation();
  const onFollowHandler = () => {
    if (isFollowLoading) return;
    follow(data);
  };

  const onDeleteHandler = () => deleteCardHandler(data);

  const onOpenHandler = () => {
    if (isFollowLoading) return;
    // new DataLayersManager().setModel(data).onClickSearchResult();
    openCard(data);
  };

  if (!data.isSuccess) {
    const errorMessage = data.searchError;
    const errorText = t(seaErrorMessageMap[errorMessage] ?? seaErrorMessageMap.CARRIER_NO_RESPONSE);
    const canChangeShippingLine = changeShippinglineErrorMessages.includes(errorMessage);

    if (errorText) {
      return renderErrorCard({
        canChangeShippingLine,
        referenceType: data.referenceType,
        text: errorText,
        status: "error",
        reference: data.reference,
        onDelete: onDeleteHandler,
        onFollow: onFollowHandler,
      });
    }
  }

  return renderCard({
    shipmentType,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    predictiveETA: data.predictiveETA,
    referenceType: data.referenceType,
    containersAmount: data.containersAmount,
    reference: data.reference,
    status: data.status,
    directionFrom: data.fromDirection,
    directionTo: data.toDirection,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
    onFollow: isFollowButtonVisible && isAuthenticated ? onFollowHandler : undefined,
    isFollowLoading: isFollowLoading,
    containersSizeTypes: data.containersSizeTypes,
    scac: data.getCarrierScac(),
    carrierName: data.carrierName,
  });
};
